import React from 'react';
import ReactDOM from 'react-dom';
import Reauth from '../components/Reauth.component';

angular.module('success').directive('reauth', reauthDirective);

/* @ngInject */
function reauthDirective() {
  return {
    restrict: 'E',
    link(scope, element) {
      ReactDOM.render(React.createElement(Reauth), element[0]);

      scope.$on('$destroy', () => {
        ReactDOM.unmountComponentAtNode(element[0]);
      });
    },
  };
}
